// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateStatus = status => ({
    data: status,
    type: actions.UPDATE_TABM_SPA_CLAIM_STATUS
});



// WEBPACK FOOTER //
// ./src/tabm/spa-details/action-creators/update-status.js